/**
 * DevExtreme (core/renderer.js)
 * Version: 19.2.6
 * Build date: Thu Jan 30 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
"use strict";
var rendererBase = require("./renderer_base");
module.exports = rendererBase.get();



//////////////////
// WEBPACK FOOTER
// ./~/devextreme/core/renderer.js
// module id = 2
// module chunks = 0